import {Stack, Chip} from "@mui/material";
import {FilterType} from "../../../../../config/enums";
import {ViewModelProps} from "../../../../../config/type";

type FilterTypeUnion =
  | FilterType.ATTEMPT_STATUS
  | FilterType.DIFFICULTY
  | FilterType.PATTERN;

interface FilterChipProps {
  id: string;
  viewModel: ViewModelProps;
}
interface FiltersProps {
  [FilterType.ATTEMPT_STATUS]: FilterChipProps[];
  [FilterType.PATTERN]: FilterChipProps[];
  [FilterType.DIFFICULTY]: FilterChipProps[];
}

interface SelectedFiltersRowUIProps {
  filters: FiltersProps;
  onFitersUpdate: (
    filterType: FilterTypeUnion,
    selectedFilters: string[],
  ) => void;
}
export default function SelectedFiltersRowUI({
  filters: {
    [FilterType.ATTEMPT_STATUS]: attemptStatus,
    [FilterType.PATTERN]: patterns,
    [FilterType.DIFFICULTY]: difficulty,
  },
  onFitersUpdate,
}: SelectedFiltersRowUIProps) {
  const getFiltersForType = (filterType: FilterTypeUnion) => {
    const filterMap = {
      [FilterType.ATTEMPT_STATUS]: attemptStatus,
      [FilterType.PATTERN]: patterns,
      [FilterType.DIFFICULTY]: difficulty,
    };
    return filterMap[filterType];
  };

  const removeFilter = (filterType: FilterTypeUnion, filterId: string) => {
    const currentFilters = getFiltersForType(filterType);
    const existingValues = currentFilters
      .filter(item => item.id !== filterId)
      .map(item => item.id);
    console.log("existingValues", existingValues);
    onFitersUpdate(filterType, existingValues);
  };

  function FilterChip({filterType}: {filterType: FilterTypeUnion}) {
    const filters = getFiltersForType(filterType);
    return (
      <>
        {filters.map(filter => (
          <Chip
            key={`${filterType}-${filter.id}`}
            label={filter.viewModel.name}
            onDelete={() => removeFilter(filterType, filter.id)}
            size="small"
          />
        ))}
      </>
    );
  }

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" mt={2}>
      <FilterChip filterType={FilterType.PATTERN} />
      <FilterChip filterType={FilterType.DIFFICULTY} />
      <FilterChip filterType={FilterType.ATTEMPT_STATUS} />
    </Stack>
  );
}
